import e from "qs";
import { createElement as r, Children as t, Component as n } from "react";
import o from "prop-types";

var i = function i(e, r, t) {
  return Object.defineProperty(e, r, {
    enumerable: !1,
    configurable: !1,
    writable: !1,
    value: t
  }), e;
};

function s(r, t) {
  if (null == t) return r;
  var n = e.stringify(t);
  return n ? r + (r.indexOf("?") < 0 ? "?" : "&") + n : r;
}

var c = function (n) {
  function o(e) {
    n.call(this, e), this.state = {
      processing: !0,
      state: null,
      error: null
    }, this.getAuthorizationCode = this.getAuthorizationCode.bind(this), this.handleError = this.handleError.bind(this), this.parseQuerystring = this.parseQuerystring.bind(this);
  }

  return n && (o.__proto__ = n), (o.prototype = Object.create(n && n.prototype)).constructor = o, o.prototype.componentDidMount = function () {
    this.getAuthorizationCode();
  }, o.prototype.getAuthorizationCode = function () {
    var e = this;

    try {
      var r = this.props,
          t = r.tokenUrl,
          n = r.tokenFetchArgs,
          o = r.clientId,
          c = r.clientSecret,
          u = r.redirectUri,
          l = r.args,
          a = r.tokenFn,
          p = r.onAuthSuccess,
          h = this.parseQuerystring(),
          d = h.error,
          f = h.error_description,
          g = h.code,
          y = JSON.parse(h.state || null);
      if (y && this.setState(function () {
        return {
          state: y
        };
      }), null != d) throw new Error(f);
      var b = s("" + t, Object.assign({}, {
        code: g,
        grant_type: "authorization_code",
        client_id: o,
        client_secret: c,
        redirect_uri: u
      }, l)),
          m = new Headers({
        "Content-Type": "application/json"
      }),
          v = Object.assign({
        method: "POST",
        headers: m
      }, n);
      ("function" == typeof a ? a(b, v) : function (e, r) {
        var t = fetch(e, r);
        return t.then(function (e) {
          if (!e.ok) throw e;
          return e.json();
        }).catch(function (e) {
          return e.json().then(function (r) {
            var n = new Error(e.statusText);
            throw i(n, "response", e), i(n.response, "data", r), i(n, "request", t), n;
          });
        });
      }(b, v)).then(function (r) {
        "function" == typeof p && p(r.access_token, {
          response: r,
          state: y
        }), e.setState(function () {
          return {
            processing: !1
          };
        });
      }).catch(function (r) {
        e.handleError(r), e.setState(function () {
          return {
            processing: !1
          };
        });
      });
    } catch (e) {
      this.handleError(e), this.setState(function () {
        return {
          processing: !1
        };
      });
    }
  }, o.prototype.handleError = function (e) {
    var r = this.props.onAuthError;
    this.setState(function () {
      return {
        error: e
      };
    }), "function" == typeof r && r(e);
  }, o.prototype.parseQuerystring = function () {
    var r,
        t = this.props,
        n = t.location,
        o = t.querystring;
    return r = null != n ? n.search : null != o ? o : window.location.search, e.parse(r, {
      ignoreQueryPrefix: !0
    });
  }, o.prototype.render = function () {
    var e = this.props,
        n = e.component,
        o = e.render,
        i = e.children,
        s = this.state,
        c = s.processing,
        u = s.state,
        l = s.error;
    return null != n ? r(n, {
      processing: c,
      state: u,
      error: l
    }) : null != o ? o({
      processing: c,
      state: u,
      error: l
    }) : null != i ? (t.only(i), i({
      processing: c,
      state: u,
      error: l
    })) : null;
  }, o;
}(n);

c.propTypes = {
  tokenUrl: o.string.isRequired,
  clientId: o.string.isRequired,
  clientSecret: o.string.isRequired,
  redirectUri: o.string.isRequired,
  args: o.objectOf(o.oneOfType([o.string, o.number, o.bool, o.object])),
  location: o.shape({
    search: o.string.isRequired
  }),
  querystring: o.string,
  tokenFn: o.func,
  onAuthSuccess: o.func,
  onAuthError: o.func,
  render: o.func,
  tokenFetchArgs: o.shape({
    method: o.string
  }),
  component: o.element,
  children: o.func
}, c.defaultProps = {
  args: {},
  location: null,
  querystring: null,
  tokenFn: null,
  onAuthSuccess: null,
  onAuthError: null,
  render: null,
  tokenFetchArgs: {},
  component: null,
  children: null
};

var u = function (e) {
  function n() {
    e.apply(this, arguments);
  }

  return e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n, n.prototype.render = function () {
    var e = this.props,
        n = e.state,
        o = e.args,
        i = e.render,
        c = e.component,
        u = e.children,
        l = s("" + e.authorizeUrl, Object.assign({}, {
      client_id: e.clientId,
      redirect_uri: e.redirectUri,
      response_type: "code",
      state: n ? JSON.stringify(n) : void 0
    }, o || {}));
    return null != c ? r(c, {
      url: l
    }) : null != i ? i({
      url: l
    }) : null != u ? (t.only(u), u({
      url: l
    })) : null;
  }, n;
}(n);

function l(e) {
  void 0 === e && (e = {});
  var r = e.authorizeUrl,
      t = e.tokenUrl,
      n = e.clientId,
      o = e.clientSecret,
      i = e.redirectUri,
      s = e.appName;
  return {
    Sender: function Sender(e) {
      return h(u, Object.assign({}, {
        authorizeUrl: r,
        clientId: n,
        redirectUri: i
      }, e));
    },
    Receiver: function Receiver(e) {
      return h(c, Object.assign({}, {
        tokenUrl: t,
        clientId: n,
        clientSecret: o,
        redirectUri: i,
        appName: s
      }, e));
    }
  };
}

u.propTypes = {
  authorizeUrl: o.string.isRequired,
  clientId: o.string.isRequired,
  redirectUri: o.string.isRequired,
  state: o.objectOf(o.oneOfType([o.string, o.number, o.bool, o.object])),
  args: o.objectOf(o.oneOfType([o.string, o.number, o.bool, o.object])),
  render: o.func,
  component: o.element,
  children: o.func
}, u.defaultProps = {
  state: null,
  args: null,
  render: null,
  component: null,
  children: null
};
export { l as createOauthFlow, u as OauthSender, c as OauthReceiver };